import { render, staticRenderFns } from "./RegionManagementModal.vue?vue&type=template&id=35ac8b29"
import script from "./RegionManagementModal.vue?vue&type=script&lang=js"
export * from "./RegionManagementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports